import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgcCookieConsentModule } from 'ngx-cookieconsent';
import { NgxSpinnerModule } from 'ngx-spinner';
import {
   HttpLoadingInterceptorService,
   HttpNoCacheInterceptorService,
   HttpResponseInterceptorService,
   HttpVersionInterceptorService,
   TrimInputsInterceptor,
} from 'src/app/main/http-service';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import packageInfo from '../../package.json';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { cookieConfig } from './config/app.config';
import { baseApiUrl } from './config/routes.config';
import { CsvDownloadComponent } from './csv-download/csv-download.component';
import { DownloadAppComponent } from './dowload-app/dowload-app.component';
import { DownloadReleaseComponent } from './download-release/download-release.component';
import { EmailConfirmComponent } from './email-confirm/email-confirm.component';
import { EmailUnsubsribeComponent } from './email-unsubsribe/email-unsubsribe.component';
import { ForgottenPasswordComponent } from './forgotten-password/forgotten-password.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { MainModule } from './main/main.module';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ReloadComponent } from './reload/reload.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SettingsComponent } from './settings/settings.component';
import { SharedModule } from './shared/shared.module';
import { ResendRecordsComponent } from './sysadmin/maintenance/resend-records/resend-records.component';

@NgModule({
   declarations: [
      AppComponent,
      LoginComponent,
      ForgottenPasswordComponent,
      ResetPasswordComponent,
      HomeComponent,
      NotFoundComponent,
      SettingsComponent,
      ReloadComponent,
      DownloadAppComponent,
      EmailConfirmComponent,
      EmailUnsubsribeComponent,
      CsvDownloadComponent,
      DownloadReleaseComponent,
      MaintenanceComponent,
      ResendRecordsComponent,
   ],
   imports: [
      AppRoutingModule,
      BrowserAnimationsModule,
      HttpClientModule,
      NgxSpinnerModule,
      ProgressbarModule,
      MainModule,
      SharedModule,
      NgcCookieConsentModule.forRoot(cookieConfig),
      TooltipModule.forRoot(),
      AccordionModule.forRoot(),
      BsDropdownModule.forRoot(),
   ],
   providers: [
      {
         provide: HTTP_INTERCEPTORS,
         useFactory: () => new HttpLoadingInterceptorService(AppComponent.spinner),
         multi: true,
      },
      {
         provide: HTTP_INTERCEPTORS,
         useFactory: () => new HttpNoCacheInterceptorService(),
         multi: true,
      },
      {
         provide: HTTP_INTERCEPTORS,
         useFactory: () =>
            new HttpResponseInterceptorService(
               (right) => AppComponent.session !== undefined,
               AppComponent.timeoutHandler,
               AppComponent.onUnauthorized,
               AppComponent.internalErrorHandler,
               AppComponent.errorHandler,
               AppComponent.onIpError,
               AppComponent.onMaintenance,
               [
                  '/api/sysadmin/search/records-data?type=rsn',
                  '/api/search/records-data?type=rsn',
                  '/api/sysadmin/maintenances/users/divisions',
                  'api/admin/maintenances/user-divisions',
                  `${baseApiUrl}/admin/password`,
                  `${baseApiUrl}/sysadmin/system-status`,
                  `${baseApiUrl}/reset-password`,
                  `${baseApiUrl}/admin/password`,
               ],
               AppComponent.reloadHandler,
            ),
         multi: true,
      },
      {
         provide: HTTP_INTERCEPTORS,
         useFactory: () => new HttpVersionInterceptorService(packageInfo.version),
         multi: true,
      },
      {
         provide: HTTP_INTERCEPTORS,
         useFactory: () => new TrimInputsInterceptor(),
         multi: true,
      },
      {
         provide: ErrorHandler,
         useValue: Sentry.createErrorHandler({
            showDialog: true,
         }),
      },
      {
         provide: Sentry.TraceService,
         deps: [Router],
      },
      {
         provide: APP_INITIALIZER,
         // eslint-disable-next-line @typescript-eslint/no-empty-function
         useFactory: () => () => {},
         deps: [Sentry.TraceService],
         multi: true,
      },
   ],
   bootstrap: [AppComponent],
})
export class AppModule {}
